import { config } from '~/shared'

export const openConfigureBotIntegrationStudioTab = (botId: string, integrationId: string) => {
  const studioUrl = `${config.studioBaseUrl}/${botId}?install=${integrationId}`
  window.open(studioUrl, '_blank')
}
